import { Typography } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as FilterFunnel01Icon } from "components/Icons/filter-funnel-01.svg";
import { ReactComponent as Sliders04Icon } from "components/Icons/sliders-04.svg";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

interface Props {
  clearFilters: () => void;
}

export const NoFilterResults = ({ clearFilters }: Props) => {
  const { message } = useMessage();
  const classes = useStyles({ fullView: false });

  return (
    <div className={classes.noResultsFilter}>
      <div className={classes.infoWrapper}>
        <div className={classes.iconWrapper}>
          <FilterFunnel01Icon className={classes.filterIcon} />
        </div>
        <Typography className={classes.noResultsTitle}>
          {message({ id: "noResultsMatchThatFilter" })}
        </Typography>
        <Typography className={classes.noResultsDesc}>
          {message({ id: "noneResultsInTableMatchTheFilter" })}
        </Typography>
        <OLButton
          startIcon={<Sliders04Icon className={classes.buttonIcon} />}
          variant="contained"
          size="medium"
          onClick={clearFilters}
        >
          {message({ id: "clearFilters" })}
        </OLButton>
      </div>
    </div>
  );
};
